package id.neotica.neotica.pages.legal

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initTermsOfServicePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("legal/TermsOfService.md", FrontMatterElement.Builder { addScalar("title", "Terms Of Service"); }))
}

@Page("/legal/terms-of-service")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun TermsOfServicePage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("terms-of-service") }) {
        org.jetbrains.compose.web.dom.Text("Terms of Service")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Effective as of 23rd of June 2025")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("These terms of service (\"Terms\") apply to your access and use of Neoverse (the \"Service\"). Under the legal entity of PT Neotica Digital Solusi. Please read them carefully.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("table-of-contents") }) {
        org.jetbrains.compose.web.dom.Text("Table of Contents")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#accepting-these-terms") {
                org.jetbrains.compose.web.dom.Text("Accepting these Terms")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#changes-to-these-terms") {
                org.jetbrains.compose.web.dom.Text("Changes to these Terms")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#privacy-policy") {
                org.jetbrains.compose.web.dom.Text("Privacy Policy")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#eligibility") {
                org.jetbrains.compose.web.dom.Text("Eligibility")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#third-party-services") {
                org.jetbrains.compose.web.dom.Text("Third-Party Services")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#creating-accounts") {
                org.jetbrains.compose.web.dom.Text("Creating Accounts")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#your-content--conduct") {
                org.jetbrains.compose.web.dom.Text("Your Content & Conduct")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#neoverse-materials") {
                org.jetbrains.compose.web.dom.Text("Neoverse Materials")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#public-domain-content") {
                org.jetbrains.compose.web.dom.Text("Public Domain Content")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#hyperlinks-and-third-party-content") {
                org.jetbrains.compose.web.dom.Text("Hyperlinks and Third Party Content")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#disclaimer-of-warranties") {
                org.jetbrains.compose.web.dom.Text("Disclaimer of Warranties")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#copyright-complaints") {
                org.jetbrains.compose.web.dom.Text("Copyright Complaints")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#governing-law") {
                org.jetbrains.compose.web.dom.Text("Governing Law")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#jurisdiction") {
                org.jetbrains.compose.web.dom.Text("Jurisdiction")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#termination-and-suspension") {
                org.jetbrains.compose.web.dom.Text("Termination & Suspension")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#entire-agreement-and-severability") {
                org.jetbrains.compose.web.dom.Text("Entire Agreement & Severability")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#feedback") {
                org.jetbrains.compose.web.dom.Text("Feedback")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#questions--contact-information") {
                org.jetbrains.compose.web.dom.Text("Questions & Contact Information")
            }
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H4(attrs = { id("accepting-these-terms") }) {
        org.jetbrains.compose.web.dom.Text("Accepting these Terms")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you access or use the Service, it means you agree to be bound by all of the terms below. So, before you use the Service, please read all of the terms. If you don't agree to all of the terms below, please do not use the Service. Also, if a term does not make sense to you, please let us know by e-mailing ")
        org.jetbrains.compose.web.dom.B {
            com.varabyte.kobweb.silk.components.navigation.Link("mailto:laetuzg@gmail.com") {
                org.jetbrains.compose.web.dom.Text("laetuzg@gmail.com")
            }
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("changes-to-these-terms") }) {
        org.jetbrains.compose.web.dom.Text("Changes to these Terms")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We reserve the right to modify these Terms at any time. For instance, we may need to change these Terms if we come out with a new feature or for some other reason.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Whenever we make changes to these Terms, the changes becomes effective after we post such revised Terms (indicated by revising the date at the top of these Terms) or upon your acceptance if we provide a mechanism for your immediate acceptance of the revised Terms (such as a click-through confirmation or acceptance button). It is your responsibility to check on the Neoverse’s  Terms and Conditions periodically for changes to these Terms.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you continue to use the Service after the revised Terms go into effect, then you have accepted the changes to these Terms.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("privacy-policy") }) {
        org.jetbrains.compose.web.dom.Text("Privacy Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To understand how we handle your data, please review our ")
        com.varabyte.kobweb.silk.components.navigation.Link("/legal/privacy-policy") {
            org.jetbrains.compose.web.dom.Text("Privacy Policy")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("eligibility") }) {
        org.jetbrains.compose.web.dom.Text("Eligibility")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To use Neoverse, you must:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Be at least 18 years old, or the legal age of majority in your jurisdiction.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Have the legal capacity to enter into a binding agreement.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Not be prohibited from using the Service under any applicable law.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("By using the Service, you represent and warrant that you meet these requirements. If you are under 18, you may not create an account or use the Service.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("third-party-services") }) {
        org.jetbrains.compose.web.dom.Text("Third-Party Services")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may integrate with or link to third-party websites or services. These are governed by their own terms and policies. You are responsible for reviewing them.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("creating-accounts") }) {
        org.jetbrains.compose.web.dom.Text("Creating Accounts")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When you create an account or log in, you must keep your credentials secure. You're responsible for all activity under your account.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you discover or suspect any Service security breaches, please let us know as soon as possible.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("your-content-conduct") }) {
        org.jetbrains.compose.web.dom.Text("Your Content & Conduct")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our Service allows you and other users to post, link and otherwise make available content. You are responsible for the content that you make available to the Service, including its legality, reliability, and appropriateness.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When you post, link or otherwise make available content to the Service, you grant us the right and license to use, reproduce, modify, publicly perform, publicly display and distribute your content on or through the Service. We may format your content for display throughout the Service, but we will not edit or revise the substance of your content itself.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Aside from our limited right to your content, you retain all of your rights to the content you post, link and otherwise make available on or through the Service. You can remove the content that you posted by deleting it. Once you delete your content, it will not appear on the Service, but copies of your deleted content may remain in our system or backups for some period of time.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You may not post, link and otherwise make available on or through the Service any of the following:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Content that is libelous, defamatory, bigoted, fraudulent or deceptive;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Content that is illegal or unlawful, that would otherwise create liability;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Content that may infringe or violate any patent, trademark, trade secret, copyright, right of privacy, right of publicity or other intellectual or other right of any party;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Mass or repeated promotions, political campaigning or commercial messages directed at users who do not follow you (SPAM);")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Private information of any third party (e.g., addresses, phone numbers, email addresses, Social Security numbers and credit card numbers); and")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Viruses, corrupted data or other harmful, disruptive or destructive files or code.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Also, you agree that you will not do any of the following in connection with the Service or other users:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Use the Service in any manner that could interfere with, disrupt, negatively affect or inhibit other users from fully enjoying the Service or that could damage, disable, overburden or impair the functioning of the Service;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Impersonate or post on behalf of any person or entity or otherwise misrepresent your affiliation with a person or entity;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Collect any personal information about other users, or intimidate, threaten, stalk or otherwise harass other users of the Service;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Create an account or post any content if you are not over 13 years of age; and")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Circumvent or attempt to circumvent any filtering, security measures, rate limits or other features designed to protect the Service, users of the Service, or third parties.")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("neoverse-materials") }) {
        org.jetbrains.compose.web.dom.Text("Neoverse Materials")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We put a lot of effort into creating the Service including, the logo and all designs, text, graphics, pictures, information and other content (excluding your content) are owned by PT Neotica Digital Solusi or licensors and are protected by copyright law.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You may not:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Modify, copy, or make derivative works")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Scrape, reverse-engineer, or download content (except caching)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Use materials for unauthorized purposes")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Violation may result in termination of access.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("public-domain-content") }) {
        org.jetbrains.compose.web.dom.Text("Public Domain Content")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Neoverse may display or make available content that is in the public domain, including literary works sourced from Project Gutenberg. These texts are believed to be free of known copyright restrictions and are offered as-is for reading and educational purposes. While we may reformat, paginate, or visually enhance this content, we make no claims of ownership over the original public domain works.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You understand that:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Public domain texts are provided without warranties of any kind, including but not limited to accuracy, completeness, or fitness for any purpose.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Any modern formatting, annotations, or additional UI features applied to public domain content remain the property of Neoverse and may not be copied or redistributed without permission.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("We do not charge for access to public domain books, nor do we claim exclusive rights to their original content.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We respect the spirit and mission of Project Gutenberg and encourage users to explore their vast digital library directly.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("hyperlinks-and-third-party-content") }) {
        org.jetbrains.compose.web.dom.Text("Hyperlinks and Third Party Content")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You may create a hyperlink to the Service. But, you may not use, frame or utilize framing techniques to enclose any of our trademarks, logos or other proprietary information without our express written consent.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Neotica makes no claim or representation regarding, and accepts no responsibility for third party websites accessible by hyperlink from the Service or websites linking to the Service. When you leave the Service, you should be aware that these Terms and our policies no longer govern.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If there is any content on the Service from you and others, we don't review, verify or authenticate it, and it may include inaccuracies or false information. We make no representations, warranties, or guarantees relating to the quality, suitability, truth, accuracy or completeness of any content contained in the Service. You acknowledge sole responsibility for and assume all risk arising from your use of or reliance on any content.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("disclaimer-of-warranties") }) {
        org.jetbrains.compose.web.dom.Text("Disclaimer of Warranties")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("THE SERVICE AND ANY OTHER SERVICE AND CONTENT INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SERVICE ARE PROVIDED TO YOU ON AN AS IS OR AS AVAILABLE BASIS WITHOUT ANY REPRESENTATIONS OR WARRANTIES OF ANY KIND. WE DISCLAIM ANY AND ALL WARRANTIES AND REPRESENTATIONS (EXPRESS OR IMPLIED, ORAL OR WRITTEN) WITH RESPECT TO THE SERVICE AND CONTENT INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SERVICE WHETHER ALLEGED TO ARISE BY OPERATION OF LAW, BY REASON OF CUSTOM OR USAGE IN THE TRADE, BY COURSE OF DEALING OR OTHERWISE.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("IN NO EVENT WILL PT Neotica Digital Solusi BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY SPECIAL, INDIRECT, INCIDENTAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES OF ANY KIND ARISING OUT OF OR IN CONNECTION WITH THE SERVICE OR ANY OTHER SERVICE AND/OR CONTENT INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SERVICE, REGARDLESS OF THE FORM OF ACTION, WHETHER IN CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR ARE AWARE OF THE POSSIBILITY OF SUCH DAMAGES. OUR TOTAL LIABILITY FOR ALL CAUSES OF ACTION AND UNDER ALL THEORIES OF LIABILITY WILL BE LIMITED TO THE AMOUNT YOU PAID TO PT Neotica Digital Solusi. THIS SECTION WILL BE GIVEN FULL EFFECT EVEN IF ANY REMEDY SPECIFIED IN THIS AGREEMENT IS DEEMED TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You agree to defend, indemnify and hold us harmless from and against any and all costs, damages, liabilities, and expenses (including attorneys' fees, costs, penalties, interest and disbursements) we incur in relation to, arising from, or for the purpose of avoiding, any claim or demand from a third party relating to your use of the Service or the use of the Service by any person using your account, including any claim that your use of the Service violates any applicable law or regulation, or the rights of any third party, and/or your violation of these Terms.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("copyright-complaints") }) {
        org.jetbrains.compose.web.dom.Text("Copyright Complaints")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We take intellectual property rights seriously. In accordance with the Digital Millennium Copyright Act (\"DMCA\") and other applicable law, we have adopted a policy of terminating, in appropriate circumstances and, at our sole discretion, access to the service for users who are deemed to be repeat infringers.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("governing-law") }) {
        org.jetbrains.compose.web.dom.Text("Governing Law")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("These Terms are governed by the laws of the ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Republic of Indonesia")
        }
        org.jetbrains.compose.web.dom.Text(", without regard to conflict of law principles.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("jurisdiction") }) {
        org.jetbrains.compose.web.dom.Text("Jurisdiction")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Disputes must be resolved exclusively in the courts of the Republic of Indonesia. You waive the right to initiate or join class actions.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("termination-and-suspension") }) {
        org.jetbrains.compose.web.dom.Text("Termination and Suspension")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you breach any of these Terms, we have the right to suspend or disable your access to or use of the Service.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("entire-agreement-and-severability") }) {
        org.jetbrains.compose.web.dom.Text("Entire Agreement and Severability")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("These Terms constitute the entire agreement between you and PT Neotica Digital Solusi regarding the use of the Service, superseding any prior agreements between you and PT Neotica Digital Solusi relating to your use of the Service.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("feedback") }) {
        org.jetbrains.compose.web.dom.Text("Feedback")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Please let us know what you think of the Service, these Terms and, in general, NEOVERSE. When you provide us with any feedback, comments or suggestions about the Service, these Terms and, in general, NEOVERSE, you irrevocably assign to us all of your right, title and interest in and to your feedback, comments and suggestions.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("questions-contact-information") }) {
        org.jetbrains.compose.web.dom.Text("Questions & Contact Information")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Questions or comments about the Service may be directed to us at the email address ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:laetuzg@gmail.com") {
            org.jetbrains.compose.web.dom.Text("laetuzg@gmail.com")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
}
